import React, { useEffect, useState, useRef } from "react";

const DnvDevAppError = () =>{

    return (
        <div className="dev-apps-error">
            <h2>Something went wrong</h2>
            <p>We&apos;re unable to display this application at the moment.</p>
            <p>You can:</p>
                <ul>
                    <li>refresh the page</li>
                    <li>try again later</li>
                    <li><a href="/government-administration/contact-us">contact support</a> if the issue persists</li>
                </ul>
            <a href="/business-development/significant-development-applications" className="link-btn">Back to applications</a>
        </div>
    )

}

DnvDevAppError.displayName = "DnvDevAppError";
export { DnvDevAppError };